<template>
    <dialog-selector
        width="644px"
        class="shop-dialog-selector"
        :class="{ 'shop-dialog-selecto--hidden_sidebar': !showSidebar }"
        ref="dialogSelector"
        :title="title"
        :multiple="multiple"
        v-on="$listeners"
        v-bind="$attrs"
        @content-scroll="onContentScroll"
        :showSidebar="showSidebar"
        :disabled-collapse="!showSidebar"
        :data="groupData"
        :defaultCheckedKeys="checkedKeys"
        :props="{ label: 'viewName', groupId: 'areaId',}"
        :sidebarProps="{label: 'viewName'}"
        search-placeholder="输入首字母或关键字检索门店"
        :filter-node-method="filterNode"
        @click-sidebar-item="onClickSidebarItem"
        :before-confirm="beforeConfirm"
        :disabled-select-child-fun="disabledSelectChildFun"
        @select-change="onSelectChange">
        <template v-slot:node="{ node }">
			<div class="shop-selector__item" :title="node.viewName">
				<span class="shop-selector__type">
					<as-icon title="总部" size="16px" class="shop_selector-icon-headquarters" name="area_selector-icon-headquarters" v-if="node.softgenre === 0"></as-icon>
                    <as-icon title="直属店" size="16px" class="shop-selector__icon-flagship" name="area_selector-icon-flagship" v-if="node.softgenre === 2"></as-icon>
                    <as-icon title="附属店" size="16px" class="shop-selector__icon-ordinary" name="area_selector-icon-ordinary" v-if="node.softgenre === 3"></as-icon>
				</span>
				<span class="emp-selector__name">{{ node.viewName | cutString(12) }}</span>
			</div>
		</template>
        <template v-slot:sidebarItem="{ menuItem }" >
			<el-badge :value="countMapData[menuItem.id]" :max="99"  v-if='multiple'>
				{{ menuItem.viewName | cutString(10) }}
			</el-badge>
		</template>
        <template v-slot:shortcut>
            <el-button v-if="allShopButtonVisible" size="medium" plain @click="handlerSelect(1)">全选门店</el-button>
            <el-button v-if="allRetailStoresVisible" size="medium" plain @click="handlerSelect(2)">全选直营门店</el-button>
        </template>
    </dialog-selector>
</template>
<script>
    import DialogSelector from '@/components/dialog-selector';
    import AsIcon from '@/components/icon'
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'ShopDialogSelector',
        components: {
            DialogSelector,
            AsIcon,
        },
        mixins: [UtilsMixins],
        props: {
            multiple: {type: Boolean, default: true},
            groupData: {
                type: Array,
                default: () => []
            },
            defaultCheckedKeys: {
                type: Array,
                default: () => []
            },
            allShopButtonVisible: {
                type: Boolean,
                default: true,
            },
            allRetailStoresVisible: {
                type: Boolean,
                default: true,
            },
            isReturnShortcutValue: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: "选择门店"
            },
            beforeConfirm: Function,
            disabledSelectChildFun: Function
        },
        computed: {
            showSidebar() {
                return this.groupData && this.groupData.length > 1 && this.allShopList.length > 10;
            },
        },
        data() {
            return {
                selectAreaId: null,
                countMapData: {},
                allShopList: [],
                allDirectShopList: [],
                checkedKeys: [],

            }
        },
        watch: {
            defaultCheckedKeys(newVal) {
                this.initCheckedKeys();
            },
            groupData(areaListData) {
                const allDirectShopList = [],
                    allShopList = [],
                    allDirectShopIdList = [],
                    allShopIdList = [];
                areaListData.forEach(areaData => {
                    areaData.children.forEach(shopData => {
                        const { softgenre } = shopData;
                        if (softgenre === 2) {
                            allDirectShopList.push(shopData);
                            allDirectShopIdList.push(shopData.id)
                        }
                        allShopList.push(shopData);
                        allShopIdList.push(shopData.id);
                    })
                })
                this.allShopList = allShopList;
                this.allDirectShopList = allDirectShopList;
                this.allShopIdList = allShopIdList;
                this.allDirectShopIdList = allDirectShopIdList;
                this.initCheckedKeys();
            }
        },
        methods: {
            onContentScroll(e) {
                if (!this.showSidebar) return;
                const targetDOM = e.target;
                const scrollTop = targetDOM.scrollTop;
                const itemDOMList = targetDOM.querySelectorAll('.el-collapse-item');
                let calcHeight = 0;
                if (scrollTop === 0) {
                    this.$refs.dialogSelector.selectMenuId = this.groupData[0].id;
                }
                for (let index = 0; index < itemDOMList.length; index++) {
                    const element = itemDOMList[index];
                    const { height } = element.getBoundingClientRect();
                    calcHeight += height;
                    if (calcHeight > scrollTop) {
                        this.$refs.dialogSelector.selectMenuId = this.groupData[index].id;
                        break;
                    }
                }
            },
            initCheckedKeys() {
                const firstValue = this.defaultCheckedKeys[0];
                if (firstValue === 'allShop') {
                    this.checkedKeys = this.allShopIdList;
                } else if (firstValue === 'allDirectShop') {
                    this.checkedKeys = this.allDirectShopIdList;
                } else {
                    this.checkedKeys = this.defaultCheckedKeys;   
                }
            },
            getShopIdsStringByList(list) {
                list = [...new Set(list)]
                return list.sort((a, b) => a - b).join(',')
            },
            handlerSelect(type) {
                const ids = type === 1 ? this.allShopList.map(item => item.id) : this.allDirectShopList.map(item => item.id);
                this.$refs.dialogSelector.setCheckedKeys(ids);
            },
            onSelectChange(groupSelectData) {
                const countMapData = {};
                Object.keys(groupSelectData).forEach(key => {
                    const length = groupSelectData[key].selectIds.length;
                    countMapData[key] = length || '';
                })
                
                this.countMapData = countMapData;
            },
            onClickSidebarItem(item, options) {
                const { contentDOM } = options;
                this.selectAreaId = item ? item.id : null;
                if (item) {
                    const targetDOM = contentDOM ? contentDOM.querySelector(`#group-${this.selectAreaId}`) : null;
                    if (targetDOM) {
                        contentDOM.scrollTo({
                            left: 0,
                            top: targetDOM.offsetTop,
                            behavior: 'smooth'
                        });
                    }
                } else {
                    contentDOM.scrollTo(0, 0);
                }
            },
            filterNode(value, data) {
                if (!value) {
                    return true;
                }
                const { viewName } = data;
                let flag = false;
                if ( /^[a-zA-Z]+$/.test(value) && window.pinyin) {
                    let str = window.pinyin(viewName, {
                        style: window.pinyin.STYLE_FIRST_LETTER
                    }).join('');
                    str = str.toLowerCase();
                    let valStr = value.toLowerCase();
                    if (str.indexOf(valStr) !== -1) flag = true;
                } 
                return viewName.indexOf(value) !== -1 || flag;
            },
        },
        mounted() {
            const dialogSelector = this.$refs.dialogSelector;
            dialogSelector.handlerConfirm = () => {
                const { mapData, selectIds, handleDialogClose } = dialogSelector;
                const checkNodes = selectIds.map(id => mapData[id]);
                const selectIdsString = this.getShopIdsStringByList(selectIds);
                const allShopIdsString = this.getShopIdsStringByList(this.allShopIdList);
                const allDirectShopIdsString = this.getShopIdsStringByList(this.allDirectShopIdList);
                let shortcutValue = undefined;
                if(this.beforeConfirm && this.beforeConfirm(checkNodes) === false) {
                   return;
                }
                if (allShopIdsString === selectIdsString) {
                    shortcutValue = 'allShop'
                } else if (allDirectShopIdsString === selectIdsString) {
                    shortcutValue = "allDirectShop";
                }
                if(this.isReturnShortcutValue){
                    this.$emit('on-confirm', checkNodes, shortcutValue);
                }else{
                    this.$emit('on-confirm', checkNodes, undefined);
                }
                handleDialogClose();
            }
        }
    }
</script>
<style lang="scss">
.shop-dialog-selector {
    &.shop-dialog-selecto--hidden_sidebar {
        .dialog-selector__content {
            margin-left: - 10px;
            margin-right: -10px;
        }
        .group-header__icon {
            visibility: hidden;
        }
    }
    &.dialog-selector__dialog--single {
        .dialog-selector__item {
            margin-right: 10px;
            flex: 0 0 calc(33.333% - 10px);
        }
    }
    .el-dialog {
        border-radius: 6px;
        border: 1px solid #CCCCCC;
        box-shadow: 0 1px 12px 0 rgba(0,0,0,0.15);
    }
    .dialog-selector {
        padding-top: 0;
    }
    .dialog-selector__menu-list {
        padding-top: 4px;
    }
    .el-dialog__header {
        display: flex;
        align-items: center;
        padding: 0 17px;
        height: 48px;
    }
    .dialog-selector__menu-list {
        height: 432px;
        box-sizing: border-box;
    }
    .dialog-selector__main {
        padding: 0 10px;
    }
    .dialog-selector__content {
        height: 336px;
    }
    .dialog-selector__footer {
        padding: 10px 0;
    }
    .el-button {
        font-size: 12px;
        height: 37px;
    }
    .el-button--medium {
        height: 32px;
    }
    .dialog-selector__item {
        flex: 0 0 33.333%;
        .emp-selector__name {
            transition: color .3s;
        }
        &:hover {
            background-color: transparent !important;
            .emp-selector__name {
                color: #409EFF;
                transition: color .3s;
            }
        }
        &.selected {
            background-color: #e6f1fe !important;
        }
    }
    .shop-selector__item {
        width: 100%;
        display: flex;
        align-items: center;
        color: #333;
        .emp-selector__name{
            display: inline-block;
            padding-left: 5px;
        }
        .shop_selector-icon-headquarters {
             color: #8f1a8b;
        }
        .shop-selector__icon-flagship {
            color: rgb(64, 158, 255)
        }
        .shop-selector__icon-ordinary {
            color: rgb(0, 207, 110);
        }
    }
}
</style>